// @flow
import { useParams } from 'react-router-dom';
import React from 'react';

import { CopyRenderer } from '../grid-utils/renderers';
import { useCopyNativeInferencePoolMutation } from '../../../service-definitions/estimates';
import { useEstimateVersion } from '../../../custom-hooks/useEstimateVersion';
import { NATIVE_INFERENCE_POOL_ID } from '../../../constants';
import { toastError, toastSuccess } from '../../presentational/notifications/utils';

export const NativeInferencePoolCopyRenderer = ({ data }) => {
  const { estimateId } = useParams();
  const estimateVersion = useEstimateVersion();
  const [copyNativeInferencePool] = useCopyNativeInferencePoolMutation();
  const nativeInferencePoolId = data[NATIVE_INFERENCE_POOL_ID];

  return (
    <CopyRenderer
      onClickHandler={async () => {
        const { error } = await copyNativeInferencePool({
          estimateId,
          nativeInferencePoolId,
          estimateVersion,
        });

        if (error) {
          toastError(error);
        } else {
          toastSuccess('Successfully copied the inference pool!');
        }
      }}
    />
  );
};
